// Matches any string that begins with `//` or `http`
const extrenalLinkRegex = /^(\/{2}|http)/;

export const isExternalLink = (url: string | null = '') => !!url && extrenalLinkRegex.test(url);
